import { withAuthHeaders } from './auth';
import { extractErrorMessageFromResponse, reportInvalidAuthIfNeeded } from './authSession';

export async function authenticatedFetch(input: RequestInfo, init: RequestInit = {}): Promise<Response> {
  const response = await fetch(input, {
    ...init,
    headers: withAuthHeaders(init.headers),
  });

  if (!response.ok) {
    const message = await extractErrorMessageFromResponse(response.clone());
    reportInvalidAuthIfNeeded(response.status, message);
  }

  return response;
}
